<template>
  <div id="app">
    <notification-manager/>
    <router-view/>
  </div>
</template>

<script>
import NotificationManager from './components/NotificationManager.vue'

export default {
  components: { NotificationManager },
  name: 'App',
}
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  background-color: #f5f5f5;
}
* {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.header {
  width: 100%;
  margin: 100px 0;
  display: flex;
  justify-content: center;
  user-select: none;
}

h2 {
  font-size: 24px;
  font-weight: 700;
  color: rgb(131, 17, 176);
  animation: sparkle 2s linear infinite;
}

@keyframes sparkle {
  0% {
    color: rgb(131, 17, 176);
  }
  50% {
    color: rgb(159, 17, 176);
  }
  100% {
    color: rgb(131, 17, 176);
  }
}

.options {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  animation: fadeIn 300ms;
}

.card > * {
  user-select: none;
}

.card {
  width: 300px;
  padding: 30px 20px 20px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: 200ms;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  animation: fadeIn 300ms;
}

.selected-label {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: rgb(173, 173, 173);
  color: rgb(255, 255, 255);
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
}

.disabled {
  opacity: 0.5!important;
  cursor: not-allowed;
}

.card-action:hover:not(.disabled) {
  transition: 200ms;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.card-action:active:not(.disabled) {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  transition: 200ms;
}

.card-action-selected {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  background-color: rgb(240, 240, 240);
}


h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 0 0;
  padding: 0;
  color: rgb(131, 17, 176);
  animation: sparkle 2s linear infinite;
}

.card > p, p.detail {
  margin: 0;
  padding: 0;
  color: rgb(136, 136, 136);
  font-size: 12px;
  margin: 10px 0 0 0;
}

h4 {
  font-size: 12px;
  font-weight: 700;
  margin: 10px 0 2px 0;
  padding: 0;
  margin-bottom: 10px;
  color: rgb(131, 17, 176);
  animation: sparkle 2s linear infinite;
}

.procon {
  margin: 0;
  padding: 0;
  color: rgb(136, 136, 136);
  font-size: 10px;
}

.next {
  position: absolute;
  padding: 40px 40px 0 40px;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: space-between
}

button {
  padding: 4px 20px;
  border: none;
  border-radius: 8px;
  background-color: rgb(131, 17, 176);
  color: rgb(255, 255, 255);
  font-size: 16px;
  cursor: pointer;
  transition: 200ms;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

button:hover {
  background-color: rgb(151, 86, 177);
  transition: 200ms;
}

button:active {
  background-color: rgb(191, 170, 199);
  transition: 200ms;
}

button:disabled {
  opacity: .2;
  cursor: not-allowed;
  transition: 200ms;
}

button.empty {
  background-color: transparent;
  color: rgb(44, 44, 44);
  border: 1px solid rgb(159, 159, 159);
}

button.empty:hover {
  background-color: rgb(240, 240, 240);
  color: rgb(44, 44, 44);
}

button.empty:active {
  background-color: rgb(205, 205, 205);
  color: rgb(44, 44, 44);
}

button.danger {
  background-color: rgb(255, 0, 0);
}

button.danger:hover {
  background-color: rgb(255, 50, 50);
}

button.danger:active {
  background-color: rgb(255, 100, 100);
}

input {
  padding: 2px 10px;
  border: none;
  border-radius: 8px;
  background-color: rgb(240, 240, 240);
  color: rgb(71, 71, 71);
  font-size: 16px;
  transition: 200ms;
  font-size: 14px;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translate(0, 10px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
  
}

</style>



// WEBPACK FOOTER //
// src/App.vue